import React from 'react';
import {
  ViewsService,
  SearchService,
  DocumentsService,
  FieldsService,
  ContentTypesService,
  LocalesService,
  CurrentUserService,
  UiAdminConfigsService,
  MsGraphService,
  ConfigurationService,
  AssignmentsService,
  TranslationsService,
  IndexesService,
  VersionsService
} from '@cs-cms/api-client';

export interface IServicesContext {
  currentUserService?: CurrentUserService;
  viewsService?: ViewsService;
  fieldsService?: FieldsService;
  contentTypesService?: ContentTypesService;
  searchService?: SearchService;
  documentsService?: DocumentsService;
  localesService?: LocalesService;
  uiAdminConfigsService?: UiAdminConfigsService;
  msGraphService?: MsGraphService;
  configurationService?: ConfigurationService;
  assignmentsService?: AssignmentsService;
  translationsService?: TranslationsService;
  indexesService?: IndexesService;
  versionsService?: VersionsService;
}

const ServicesContext = React.createContext<IServicesContext>({});

export default ServicesContext;
